import type { ReactNode } from 'react'
import { cn } from '@/components/ui'

/**
 * Le cartouche : l'aplat blanc sur lequel se pose tout ce qui porte une image.
 *
 * ⚠️ **Règle de Baptiste (2026-10-27) : une image ne flotte jamais sur le
 * crème.** Vignette de replay, couverture de module, visuel d'article : tout
 * passe dans un cartouche. Rayon 24, marge 12 ; l'image à l'intérieur prend un
 * rayon de 16 (`rounded-[16px]`), qui suit celui du cartouche.
 */
export function Cartouche({
  as: Balise = 'div',
  children,
  className,
}: {
  as?: 'div' | 'article' | 'li'
  children: ReactNode
  className?: string
}) {
  return <Balise className={cn('rounded-[24px] bg-surface p-3', className)}>{children}</Balise>
}
